import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import FeatureShowcase from "../sections/FeatureShowcase";
import FinalCTA from "../sections/FinalCTA";

export default function Features() {
  return (
    <>
      <SEO
        title="Features"
        description="Clients, scheduling, tasks, forms, documents, contracts, invoices and calendar — everything a virtual assistant business needs, in one workspace."
        path="/features"
      />
      <section className="pt-20 pb-8 bg-[#FAF7F2]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
              Features
            </div>
            <h1 className="font-display font-extrabold text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.03em] text-[#1A2A3A] mb-5">
              Every part of your client relationship, in the right place.
            </h1>
            <p className="text-[17px] text-[#57534E] max-w-2xl mx-auto leading-relaxed">
              ClientDesk VA gathers the eight things a VA business actually
              runs on into a single, honest workspace.
            </p>
          </Reveal>
        </div>
      </section>
      <FeatureShowcase />
      <FinalCTA />
    </>
  );
}
